import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/admin/PageHeader";
import Wizard from "../../components/register/Wizard";

export default function AddProfile() {
  const navigate = useNavigate();
  const [profileFor, setProfileFor] = useState(null);
  if (!profileFor) {
    return (
      <div data-testid="add-profile-picker">
        <PageHeader eyebrow="Add New Profile" title="Bride or Groom?" />
        <div className="rmm-card grid max-w-md gap-4 p-6 sm:grid-cols-2">
          {["bride", "groom"].map((v) => (
            <button
              key={v}
              type="button"
              onClick={() => setProfileFor(v)}
              data-testid={`pick-${v}`}
              className="rounded-xl border-2 border-[#D4AF37]/50 bg-white px-4 py-6 font-display text-2xl font-semibold text-[#4A000E] transition-colors hover:bg-[#F5E6BA]/40 focus:border-[#7A0016]"
            >
              {v === "bride" ? "Bride" : "Groom"}
            </button>
          ))}
        </div>
      </div>
    );
  }
  return <Wizard mode="admin" initialProfileFor={profileFor} onSubmitted={(r) => navigate(`/admin/profiles/${r.id}`, { replace: true })} />;
}
